export default {
  data: [
    {
      name: 'Padre',
      value: 'F'
    },
    {
      name: 'Madre',
      value: 'M'
    },
    {
      name: 'Hijo(a)',
      value: 'S'
    },
    {
      name: 'Abuelo',
      value: 'GF'
    },
    {
      name: 'Abuela',
      value: 'GM'
    },
    {
      name: 'Hermano(a)',
      value: 'B'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/relations.js